/**
 * Mensajes que se pueden mostrar en la página
 *
 * Debe incluirse:
 *
 * resources/views/sections/body/message-fixed.blade.php
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2003-2025 Mendikat
 * @license Mendikat
 * @version {see config/app.php}
 */

/**
 * El mensaje mostrado en la página
 *
 * Estos mensajes son una alerta fijada en alguna parte de la página,
 * bien en la parte superior o inferior de la misma, y poseen un
 * botón "x" con objeto de poder ser ocultados
 */

class Message
{
    /**
     * Iniciar el componente de mensaje
     *
     * @void
     */
    init()
    {
        /**
         * El mensaje
         */
        /** @type {HTMLElement} */
        this.message = document.querySelector('.alert-message');

        // Si el mensaje no está activo, sale
        if (null === this.message || 'off' === this.message.dataset.active) {
            return;
        }

        // Si la fecha actual es superior a la fecha de expiración del mensaje sale
        if (new Date() > new Date(this.message.dataset.expiration)) {
            return;
        }

        /**
         * El botón de ocultar el mensaje
         */
        this.messageHideButton = document.querySelector('.message-hide-button');

        // Nombre de la cookie a verificar para mostrar o no el mensaje
        this.cookieMessageName = 'mendikat-simple-message';

        this.hideMessageToClickCloseButton();

        this.createMessageCookieIfNotExists();
    }

    /**
     * Ocultar el mensaje cuando el botón de cierre "x" es presionado
     *
     * @void
     */
    hideMessageToClickCloseButton()
    {
        this.messageHideButton.addEventListener('click', ()=> {
            this.message.style.display = 'none';
            this.setCookie(this.cookieMessageName, 'off', 7);
        });
    }

    /**
     * Crea la cookie del mensaje si no existe previamente
     *
     * Si existe la cookie su valor está en "off" sale
     * Si existe la cookie y está en "on" muestra el mensaje
     *
     * Si la cookie no existía previamente la crea con el valor "on"
     *
     * @void
     */
    createMessageCookieIfNotExists()
    {
        // Obtiene el valor de la cookie
        const cookieValue = this.getCookie(this.cookieMessageName);

         // Comprueba si el valor de la cookie es "off"
        if ('off' === cookieValue) {
            return;
        }

        // Muestra el mensaje
        this.message.classList.remove('collapse');

        // Comprueba si el valor de la cookie es "on"
        if ('on' === cookieValue) {
            return;
        }

        // Fija el valor de la cookie en "on"
        this.setCookie(this.cookieMessageName, 'on');
    }

    /**
     * Obtiene el valor de una cookie
     *
     * @param {String} cookieName
     *
     * @returns {String}
     */
    getCookie(cookieName)
    {
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();

          if (cookie.startsWith(cookieName + '=')) {
                return cookie.substring(cookieName.length + 1);
          }
        }

        return null; // Si no se encuentra la cookie, devuelve null
    }

    /**
     * Fija el valor de una cookie
     *
     * @param {String} cookieName
     * @param {String} cookieValue
     * @param {Number} days
     *
     * @void
     */
    setCookie(cookieName, cookieValue, days)
    {
        // Establece una fecha de expiración de n días
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (days * 24 * 60 * 60 * 1000));

        // Convierte la fecha de expiración a formato de cadena GMT
        const expirationDateString = expirationDate.toGMTString();

        // Sobrescribe la cookie con la fecha de expiración en el pasado
        document.cookie = `${cookieName}=${cookieValue}; expires=${expirationDateString}; path=/`;
    }

    /**
     * Elimina una cookie
     *
     * @param {String} cookieName
     *
     * @void
     */
    removeCookie(cookieName)
    {
        // Establece una fecha de expiración en el pasado (por ejemplo, 1 de enero de 1970)
        const expirationDate = new Date('Thu, 01 Jan 1970 00:00:00 UTC');

        // Convierte la fecha de expiración a formato de cadena GMT
        const expirationDateString = expirationDate.toGMTString();

        // Sobrescribe la cookie con la fecha de expiración en el pasado
        document.cookie = `${cookieName}=; expires=${expirationDateString}; path=/`;
    }
}

//
// Carga el componente
//
new Message().init();
